import { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { updateBrowserControlState } from '@wg/web2clientapi/browser/updateBrowserControlState';

import { root } from '~/preloaded';
import { useAppDispatch, useAppSelector } from '~/store';
import { isDialogOpenSelector } from '~/store/selectors/dialogsSelectors';
import { searchResultIsFetchedBeforeSelector } from '~/store/selectors/searchSelectors';
import { isClanHubEnabledSelector } from '~/store/selectors/settingsSelector';
import { supplySelectedBuildingIdSelector } from '~/store/selectors/supplySelectors';
import { actionsProcessing } from '~/Actions/ActionProcessing';

import useKeyDown, { KEYS_CODE } from './useKeyDown';

export default (returnUrl: string | null) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const isAnyDialogOpened = useAppSelector(isDialogOpenSelector);
  const isClanHubEnabled = useAppSelector(isClanHubEnabledSelector);
  const supplySelectedBuildingId = useAppSelector(supplySelectedBuildingIdSelector);
  const searchResultIsFetchedBefore = useAppSelector(searchResultIsFetchedBeforeSelector);

  const isClanHubNestedRoute = isClanHubEnabled && pathname !== root;
  const isControlStateEnabled = isAnyDialogOpened || supplySelectedBuildingId !== null || searchResultIsFetchedBefore;

  const browserHasControl = isControlStateEnabled || isClanHubNestedRoute;

  useEffect(() => {
    void updateBrowserControlState(browserHasControl);
  }, [browserHasControl]);

  const handleESC = useCallback(() => {
    if (returnUrl) {
      void updateBrowserControlState(false);
      dispatch(actionsProcessing.startFetching());
      window.location.href = returnUrl;
      return;
    }

    if (!isClanHubNestedRoute || isControlStateEnabled) {
      return;
    }

    navigate(root, { replace: true });
  }, [isClanHubNestedRoute, isControlStateEnabled, navigate, returnUrl, dispatch]);

  useKeyDown(handleESC, [KEYS_CODE.ESC]);
};
